import { Component, OnInit, ViewChildren } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ItemLibraryService } from 'app/infrastructure/services/itemLibrary.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { ItemParametrization } from 'app/infrastructure/model/classes/ItemParametrization.class';

@Component({
  selector: 'item-library-import',
  templateUrl: 'item-library-import.component.html'
})

export class ItemLibraryImportComponent implements OnInit {
  codsistema: string;
  businessCode: string;
  codlibrary: string;
  parametrization: ItemParametrization;
   
 


  constructor(private aRoute: ActivatedRoute,
    private router: Router,
    private serviceLibrary: ItemLibraryService,
    private alertService: AlertService, ) {}

  ngOnInit() {    
    this.codlibrary = this.aRoute.snapshot.params.codlibrary;

    this.serviceLibrary
      .getFullParametrization(this.codlibrary)
      .subscribe(parametrization => this.parametrization = parametrization);
  }

  import() {
    this.serviceLibrary
      .parametrize(this.codsistema, this.codlibrary, this.parametrization)
      .subscribe(res => {
          this.alertService.showGrowl({
            type: GrowlType.SUCCESS,
            body: 'IMPORTACION_EXITOSA'
          });

          if (this.businessCode) {
            this.router.navigate(['../../..'], {relativeTo: this.aRoute});
          } else {
            this.router.navigate(['../..'], {relativeTo: this.aRoute});
          }
      });
  }
}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/item-library/item-library-import.component.ts